// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --pastel: #F1C19F;
  --pasteldark: #FD935D;
  --brightlight: #C2F2FE;
  --brightvlight: #EBF7FF;
  --bright: #82E4FD;
  --brightdark: #04C2F1;
  --pastellight: #F8DDC9;
  --dark: #FFFFFF;
  --borderW: 2px;
}

/* Gradient buttons */
.button-text {
  font-size: 20px;
  padding-top: 5%;
  color: white;
  font-family: Nunito, sans-serif; font-style: bold;
}

@media screen and (max-width: 899.99px) {
  .button-text {
    font-size: 18px;
    padding-top: 5%;
    color: white;
    font-family: Nunito, sans-serif; font-style: bold;
  }
}

.btn-stand {
  padding: 10px;
  text-align: center;
  align-items: center;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  font-family: 'Nunito', sans-serif;
  font-size: 24px;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  border-color: transparent;
}

.btn-stand:active {
  top: 1px;
}

.btn-stand:hover {
  background-position: right center;
}

.btn-gradient-bright {
  color: white;
  background-image: linear-gradient(to right, var(--main-col3) 0%, var(--main-col2) 51%, var(--main-col3) 100%);
}

.btn-gradient-warn {
  color: white;
  background-image: linear-gradient(to right, orange 0%, red 51%, orange 100%);
}

.btn-gradient-pastel {
  color: white;
  background-image: linear-gradient(to right, var(--pastel) 0%, var(--pastellight) 51%, var(--pastel) 100%);
}

.btn-gradient-orange {
  color: white;
  background-image: linear-gradient(to right, var(--pasteldark) 0%, var(--brightdark) 51%, var(--pasteldark) 100%);
}

.ant-spin-dot-item {
  background-color: var(--bright);
}

.btn-chip-grey {
  align-items: center;
  background-color: #F8F8F8;
  background-position: 0 0;
  border: 1px solid lightgrey;
  border-radius: 11px;
  box-sizing: border-box;
  color: lightgrey;
  cursor: pointer;
  font-weight: 700;
  line-height: 33.4929px;
  padding: 2px 12px;
  text-decoration: none;
  text-shadow: none;
  text-underline-offset: 1px;
  transition: border .2s ease-in-out, box-shadow .2s ease-in-out;
  user-select: none;
  white-space: nowrap;
  word-break: break-word;
}

.btn-chip-bright {
  align-items: center;
  background-color: var(--brightvlight);
  background-position: 0 0;
  border: 1px solid var(--bright);
  border-radius: 11px;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, .1) 0 5px 15px;
  color: var(--brightdark);
  cursor: pointer;
  font-weight: 700;
  line-height: 33.4929px;
  padding: 2px 12px;
  text-decoration: none;
  text-shadow: none;
  text-underline-offset: 1px;
  transition: border .2s ease-in-out, box-shadow .2s ease-in-out;
  user-select: none;
  white-space: nowrap;
  word-break: break-word;
}

.btn-chip-bright:active,
.btn-chip-bright:hover,
.btn-chip-bright:focus {
  outline: 0;
}

.btn-chip-bright:active {
  background-color: var(--brightvlight);
  box-shadow: rgba(0, 0, 0, 0.12) 0 1px 3px 0 inset;
  color: var(--dark);
}

.btn-chip-bright:hover {
  background-color: var(--bright);
  border-color: var(--brightdark);
}

.btn-chip-bright:active:hover,
.btn-chip-bright:focus:hover,
.btn-chip-bright:focus {
  background-color: var(--bright);
  box-shadow: rgba(0, 0, 0, 0.12) 0 1px 3px 0 inset;
  color: var(--dark);
}

.elevated-button {
  cursor: pointer;
  top: 0;
  transition: top ease 0.2s;
}

.elevated-button:hover {
  opacity: 0.9;
  scale: 2;
  z-index: 100;
  top: -5px;
  position: relative;
}

/* Buttons */
.buttons {
  margin-top: 20px;
  text-align: center;
  border-radius: 20px;
}

.blob-btn {
  font-family: Gaegu, sans-serif; 
  --numOfBlobs: 4;
  z-index: 1;
  position: relative;
  padding: 8px 15px;
  text-align: center;
  color: var(--bright);
  font-size: 18px;
  font-weight: bold;
  background-color: transparent;
  outline: none;
  border: none;
  transition: color 0.5s;
  cursor: pointer;
  border-radius: 30px;
}

.blob-btn:before {
  content: "";
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: var(--borderW) solid var(--bright);
  border-radius: 10px;
}

.blob-btn:after {
  content: "";
  z-index: -2;
  position: absolute;
  left: calc(var(--borderW) * 1.5);
  top: calc(var(--borderW) * 1.5);
  width: 100%;
  height: 100%;
  transition: all 0.3s 0.2s;
  border-radius: 10px;
}

.blob-btn:hover {
  color: var(--dark);
  border-radius: 10px;
}

.blob-btn:after {
  transition: all 0.3s;
  left: 0;
  top: 0;
  border-radius: 10px;
}

.blob-btn__inner {
  z-index: -1;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: transparent;
}

.blob-btn__blobs {
  position: relative;
  display: block;
  height: 100%;
  filter: url('#goo');
}

.blob-btn__blob {
  position: absolute;
  top: var(--borderW);
  width: calc(100% / var(--numOfBlobs));
  height: 100%;
  background: linear-gradient(to right, var(--bright) 0%, var(--brightdark) 100%);
  border-radius: 100%;
  transform: translate3d(0, 150%, 0) scale(1.7);
  transition: transform 0.45s;
}

.blob-btn__blob:nth-child(1) {
  left: 0;
  transition-delay: 0s;
}

.blob-btn__blob:nth-child(2) {
  left: 30%;
  transition-delay: 0.08s;
}

.blob-btn__blob:nth-child(3) {
  left: 60%;
  transition-delay: 0.16s;
}

.blob-btn__blob:nth-child(4) {
  left: 90%;
  transition-delay: 0.24s;
}

.blob-btn:hover .blob-btn__blob {
  transform: translateZ(0) scale(1.7);
}

/* Gooey filter for blobs */
:root {
  --goo-strength: 2;
}

#goo {
  width: 100%;
  height: 100%;
  filter: url('#gooey');
}

.feGaussianBlur {
  stdDeviation: var(--goo-strength);
}
`, "",{"version":3,"sources":["webpack://./frontend/src/styles/_homepage.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,+BAA+B,EAAE,gBAAgB;AACnD;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,+BAA+B,EAAE,gBAAgB;EACnD;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,6GAA6G;AAC/G;;AAEA;EACE,YAAY;EACZ,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,yGAAyG;AAC3G;;AAEA;EACE,YAAY;EACZ,gHAAgH;AAClH;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,8DAA8D;EAC9D,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,8DAA8D;EAC9D,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;EAC/B,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,OAAO;EACP,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,+EAA+E;EAC/E,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* Variables */\n:root {\n  --pastel: #F1C19F;\n  --pasteldark: #FD935D;\n  --brightlight: #C2F2FE;\n  --brightvlight: #EBF7FF;\n  --bright: #82E4FD;\n  --brightdark: #04C2F1;\n  --pastellight: #F8DDC9;\n  --dark: #FFFFFF;\n  --borderW: 2px;\n}\n\n/* Gradient buttons */\n.button-text {\n  font-size: 20px;\n  padding-top: 5%;\n  color: white;\n  font-family: Nunito, sans-serif; font-style: bold;\n}\n\n@media screen and (max-width: 899.99px) {\n  .button-text {\n    font-size: 18px;\n    padding-top: 5%;\n    color: white;\n    font-family: Nunito, sans-serif; font-style: bold;\n  }\n}\n\n.btn-stand {\n  padding: 10px;\n  text-align: center;\n  align-items: center;\n  transition: 0.5s;\n  background-size: 200% auto;\n  color: white;\n  font-family: 'Nunito', sans-serif;\n  font-size: 24px;\n  box-shadow: 0 0 20px #eee;\n  border-radius: 10px;\n  border-color: transparent;\n}\n\n.btn-stand:active {\n  top: 1px;\n}\n\n.btn-stand:hover {\n  background-position: right center;\n}\n\n.btn-gradient-bright {\n  color: white;\n  background-image: linear-gradient(to right, var(--main-col3) 0%, var(--main-col2) 51%, var(--main-col3) 100%);\n}\n\n.btn-gradient-warn {\n  color: white;\n  background-image: linear-gradient(to right, orange 0%, red 51%, orange 100%);\n}\n\n.btn-gradient-pastel {\n  color: white;\n  background-image: linear-gradient(to right, var(--pastel) 0%, var(--pastellight) 51%, var(--pastel) 100%);\n}\n\n.btn-gradient-orange {\n  color: white;\n  background-image: linear-gradient(to right, var(--pasteldark) 0%, var(--brightdark) 51%, var(--pasteldark) 100%);\n}\n\n.ant-spin-dot-item {\n  background-color: var(--bright);\n}\n\n.btn-chip-grey {\n  align-items: center;\n  background-color: #F8F8F8;\n  background-position: 0 0;\n  border: 1px solid lightgrey;\n  border-radius: 11px;\n  box-sizing: border-box;\n  color: lightgrey;\n  cursor: pointer;\n  font-weight: 700;\n  line-height: 33.4929px;\n  padding: 2px 12px;\n  text-decoration: none;\n  text-shadow: none;\n  text-underline-offset: 1px;\n  transition: border .2s ease-in-out, box-shadow .2s ease-in-out;\n  user-select: none;\n  white-space: nowrap;\n  word-break: break-word;\n}\n\n.btn-chip-bright {\n  align-items: center;\n  background-color: var(--brightvlight);\n  background-position: 0 0;\n  border: 1px solid var(--bright);\n  border-radius: 11px;\n  box-sizing: border-box;\n  box-shadow: rgba(0, 0, 0, .1) 0 5px 15px;\n  color: var(--brightdark);\n  cursor: pointer;\n  font-weight: 700;\n  line-height: 33.4929px;\n  padding: 2px 12px;\n  text-decoration: none;\n  text-shadow: none;\n  text-underline-offset: 1px;\n  transition: border .2s ease-in-out, box-shadow .2s ease-in-out;\n  user-select: none;\n  white-space: nowrap;\n  word-break: break-word;\n}\n\n.btn-chip-bright:active,\n.btn-chip-bright:hover,\n.btn-chip-bright:focus {\n  outline: 0;\n}\n\n.btn-chip-bright:active {\n  background-color: var(--brightvlight);\n  box-shadow: rgba(0, 0, 0, 0.12) 0 1px 3px 0 inset;\n  color: var(--dark);\n}\n\n.btn-chip-bright:hover {\n  background-color: var(--bright);\n  border-color: var(--brightdark);\n}\n\n.btn-chip-bright:active:hover,\n.btn-chip-bright:focus:hover,\n.btn-chip-bright:focus {\n  background-color: var(--bright);\n  box-shadow: rgba(0, 0, 0, 0.12) 0 1px 3px 0 inset;\n  color: var(--dark);\n}\n\n.elevated-button {\n  cursor: pointer;\n  top: 0;\n  transition: top ease 0.2s;\n}\n\n.elevated-button:hover {\n  opacity: 0.9;\n  scale: 2;\n  z-index: 100;\n  top: -5px;\n  position: relative;\n}\n\n/* Buttons */\n.buttons {\n  margin-top: 20px;\n  text-align: center;\n  border-radius: 20px;\n}\n\n.blob-btn {\n  font-family: Gaegu, sans-serif; \n  --numOfBlobs: 4;\n  z-index: 1;\n  position: relative;\n  padding: 8px 15px;\n  text-align: center;\n  color: var(--bright);\n  font-size: 18px;\n  font-weight: bold;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  transition: color 0.5s;\n  cursor: pointer;\n  border-radius: 30px;\n}\n\n.blob-btn:before {\n  content: \"\";\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border: var(--borderW) solid var(--bright);\n  border-radius: 10px;\n}\n\n.blob-btn:after {\n  content: \"\";\n  z-index: -2;\n  position: absolute;\n  left: calc(var(--borderW) * 1.5);\n  top: calc(var(--borderW) * 1.5);\n  width: 100%;\n  height: 100%;\n  transition: all 0.3s 0.2s;\n  border-radius: 10px;\n}\n\n.blob-btn:hover {\n  color: var(--dark);\n  border-radius: 10px;\n}\n\n.blob-btn:after {\n  transition: all 0.3s;\n  left: 0;\n  top: 0;\n  border-radius: 10px;\n}\n\n.blob-btn__inner {\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  background: transparent;\n}\n\n.blob-btn__blobs {\n  position: relative;\n  display: block;\n  height: 100%;\n  filter: url('#goo');\n}\n\n.blob-btn__blob {\n  position: absolute;\n  top: var(--borderW);\n  width: calc(100% / var(--numOfBlobs));\n  height: 100%;\n  background: linear-gradient(to right, var(--bright) 0%, var(--brightdark) 100%);\n  border-radius: 100%;\n  transform: translate3d(0, 150%, 0) scale(1.7);\n  transition: transform 0.45s;\n}\n\n.blob-btn__blob:nth-child(1) {\n  left: 0;\n  transition-delay: 0s;\n}\n\n.blob-btn__blob:nth-child(2) {\n  left: 30%;\n  transition-delay: 0.08s;\n}\n\n.blob-btn__blob:nth-child(3) {\n  left: 60%;\n  transition-delay: 0.16s;\n}\n\n.blob-btn__blob:nth-child(4) {\n  left: 90%;\n  transition-delay: 0.24s;\n}\n\n.blob-btn:hover .blob-btn__blob {\n  transform: translateZ(0) scale(1.7);\n}\n\n/* Gooey filter for blobs */\n:root {\n  --goo-strength: 2;\n}\n\n#goo {\n  width: 100%;\n  height: 100%;\n  filter: url('#gooey');\n}\n\n.feGaussianBlur {\n  stdDeviation: var(--goo-strength);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
